export default __webpack_public_path__ + "static/media/lifestyle-lines.6a0cc3bd.jpg";